import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import "./App.css";

import Landing from "./pages/Landing";
import CustomerLogin from "./pages/customer/Login";
import CustomerRegister from "./pages/customer/Register";
import CustomerKYC from "./pages/customer/KYC";
import CustomerLayout from "./components/layouts/CustomerLayout";
import CustomerDashboard from "./pages/customer/Dashboard";
import CustomerLots from "./pages/customer/Lots";
import CustomerLotDetail from "./pages/customer/LotDetail";
import CustomerPortfolio from "./pages/customer/Portfolio";
import CustomerPortfolioDetail from "./pages/customer/PortfolioDetail";
import CustomerChat from "./pages/customer/Chat";
import CustomerInvoices from "./pages/customer/Invoices";
import CustomerReferrals from "./pages/customer/Referrals";

import AdminLogin from "./pages/admin/Login";
import AdminLayout from "./components/layouts/AdminLayout";
import AdminDashboard from "./pages/admin/Dashboard";
import AdminKYC from "./pages/admin/KYCQueue";
import AdminAnimals from "./pages/admin/Animals";
import AdminLots from "./pages/admin/Lots";
import AdminLotDetail from "./pages/admin/LotDetail";
import AdminSales from "./pages/admin/Sales";
import AdminConfig from "./pages/admin/Config";
import AdminCustomers from "./pages/admin/Customers";
import AdminReports from "./pages/admin/Reports";

function CustomerRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <FullLoader />;
  if (!user || user.role !== "customer") return <Navigate to="/login" replace />;
  return children;
}

function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <FullLoader />;
  if (!user || user.role !== "admin") return <Navigate to="/admin/login" replace />;
  return children;
}

function FullLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F4E9]">
      <div className="text-[#D71921] font-display text-2xl animate-pulse">PassiveIearn</div>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster richColors position="top-right" />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<CustomerLogin />} />
          <Route path="/register" element={<CustomerRegister />} />

          <Route element={<CustomerRoute><CustomerLayout /></CustomerRoute>}>
            <Route path="/dashboard" element={<CustomerDashboard />} />
            <Route path="/kyc" element={<CustomerKYC />} />
            <Route path="/lots" element={<CustomerLots />} />
            <Route path="/lots/:id" element={<CustomerLotDetail />} />
            <Route path="/portfolio" element={<CustomerPortfolio />} />
            <Route path="/portfolio/:id" element={<CustomerPortfolioDetail />} />
            <Route path="/chat" element={<CustomerChat />} />
            <Route path="/invoices" element={<CustomerInvoices />} />
            <Route path="/referrals" element={<CustomerReferrals />} />
          </Route>

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route element={<AdminRoute><AdminLayout /></AdminRoute>}>
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/kyc" element={<AdminKYC />} />
            <Route path="/admin/customers" element={<AdminCustomers />} />
            <Route path="/admin/animals" element={<AdminAnimals />} />
            <Route path="/admin/lots" element={<AdminLots />} />
            <Route path="/admin/lots/:id" element={<AdminLotDetail />} />
            <Route path="/admin/sales" element={<AdminSales />} />
            <Route path="/admin/config" element={<AdminConfig />} />
            <Route path="/admin/reports" element={<AdminReports />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
